module.exports = __webpack_public_path__ + "img/rec-16.00fcf494.png";